import { createAction } from '@reduxjs/toolkit';

export const LOGIN = createAction('LOGIN');
export const LOGIN_SUCCESS = createAction('LOGIN_SUCCESS');
export const LOGIN_FAIL = createAction('LOGIN_FAIL');
export const LOGOUt = createAction('LOGOUt');
export const UPDATE = createAction('UPDATE');
